<div class="dialog-wrapper">
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="selectAllControlElement | translateElements"
    [formGroup]="selectAllForm"
    [rowHeight]="35">
  </dv-dynamic-form>
  <div class="dialog-wrapper__separation-line"></div>
  <div class="dialog-wrapper__search-form">
    <dv-dynamic-form
      class="dynamic-form"
      [elements]="searchControlElement | translateElements"
      [formGroup]="searchForm">
    </dv-dynamic-form>
    <span class="dv-icons">search</span>
  </div>
  <div class="dialog-wrapper__groups-form">
    <dv-dynamic-form
      class="dynamic-form"
      [elements]="groupsElements | translateElements"
      [formGroup]="groupsForm"
      [gapY]="5">
    </dv-dynamic-form>
  </div>
</div>
